/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1Fincen314FileState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_FINCEN314_FILE_STATE_ENTITY_NAME = 'ixf.watchlist.v1.Fincen_314File';
export const ixfWatchlistV1Fincen314FileStateEntity = new schema.Entity<IxfWatchlistV1Fincen314FileState>(IXF_WATCHLIST_V1_FINCEN314_FILE_STATE_ENTITY_NAME, {}, { idAttribute: 'fincen314FileId' });

